import { render, staticRenderFns } from "./couponExamine.vue?vue&type=template&id=52477905&scoped=true&"
import script from "./couponExamine.vue?vue&type=script&lang=js&"
export * from "./couponExamine.vue?vue&type=script&lang=js&"
import style0 from "./couponExamine.vue?vue&type=style&index=0&id=52477905&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52477905",
  null
  
)

export default component.exports